import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MediaObserver, MediaChange } from '@angular/flex-layout';

@Component({
  selector: 'app-library',
  templateUrl: './library.component.html',
  styleUrls: ['./library.component.css']
})
export class LibraryComponent implements OnInit {

  numColumns: number = 5;
  squareSize: number = 240;
  heightSize: number = 240;
  isMobile: boolean = false;

  @Input() cardsType: string;
  @Input() cards: any;
  @Input() heightSizes: number;
  @Output('reload') reloadEvent: EventEmitter<any> = new EventEmitter();

  constructor(private watcher: MediaObserver) { }

  ngOnInit(): void {

    this.watcher.media$
      .subscribe((change: MediaChange) => {
        switch (change.mqAlias) {
          case 'xs':
            this.numColumns = 1;
            this.squareSize = 240;
            this.isMobile = true;
            break;
          case 'sm':
            this.numColumns = 3;
            this.squareSize = 240;
            this.isMobile = true;
            break;
          case 'md':
            this.numColumns = 3;
            this.squareSize = 240;
            this.isMobile = false;
            break;
          case 'lg':
            this.numColumns = 4;
            this.squareSize = 240;
            this.isMobile = false;
            break;
          case 'xl':
            this.numColumns = 6;
            this.squareSize = 240;
            this.isMobile = false;
            break;
          default:
            this.numColumns = 4;
            this.squareSize = 190;
            this.isMobile = false;
            break;
        }
        if (this.heightSizes){
          this.squareSize=this.heightSizes;
        }
        this.heightSize = this.squareSize;
      });

  }


}
